'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookContextPage = require('@narvar/nth-hook-context-page');
var growthbookReact = require('@growthbook/growthbook-react');
var layoutTree = require('./layoutTree.js');
var renderLayout = require('./renderLayout.js');
var gridComponents = require('./gridComponents.js');
var nthBitGrid = require('@narvar/nth-bit-grid');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const defaultViewRenderProp = options => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const Wrapper = options !== null && options !== void 0 && options.isCssGridEnabled ? nthBitGrid.Container : gridComponents.containerComponent;
  return /*#__PURE__*/React__default["default"].createElement(Wrapper, null, options === null || options === void 0 ? void 0 : options.children);
};
const defaultRowRenderProp = options => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const Wrapper = options !== null && options !== void 0 && options.isCssGridEnabled ? React.Fragment : gridComponents.rowComponent;
  return /*#__PURE__*/React__default["default"].createElement(Wrapper, null, options === null || options === void 0 ? void 0 : options.children);
};
const defaultColRenderProp = options => {
  var _options$node2, _options$node2$width;
  if (!(options !== null && options !== void 0 && options.isCssGridEnabled)) {
    var _options$node;
    return /*#__PURE__*/React__default["default"].createElement(gridComponents.columnComponent, {
      "xs-columns": (options === null || options === void 0 ? void 0 : (_options$node = options.node) === null || _options$node === void 0 ? void 0 : _options$node.width) || 12
    }, options === null || options === void 0 ? void 0 : options.children);
  }
  const span = (options === null || options === void 0 ? void 0 : (_options$node2 = options.node) === null || _options$node2 === void 0 ? void 0 : (_options$node2$width = _options$node2.width) === null || _options$node2$width === void 0 ? void 0 : _options$node2$width.toString()) ?? '12';
  return /*#__PURE__*/React__default["default"].createElement(nthBitGrid.Column, {
    span: span
  }, options === null || options === void 0 ? void 0 : options.children);
};
const evaluateCondition = (conditionOperand, operator, value) => {
  switch (operator) {
    case layoutTree.ConditionOperator.NEQ:
      return conditionOperand !== value;
    case layoutTree.ConditionOperator.IN:
      if (Array.isArray(conditionOperand)) {
        return conditionOperand.includes(value);
      }
      // eslint-disable-next-line no-console
      console.error(`Array operand was not specified for IN operator: ${JSON.stringify({
        conditionOperand,
        operator,
        value
      })}`);
      return false;
    case layoutTree.ConditionOperator.EQ:
    default:
      return conditionOperand === value;
  }
};
const filterLayoutForConditions = (node, status, subStatus, carrier, category) => {
  const newNode = {
    ...node
  };
  if (newNode.type === layoutTree.TreeNodeTypes.ROW) {
    newNode.children = newNode.children.map(child => filterLayoutForConditions(child, status, subStatus, carrier, category));
    return newNode;
  } else if (newNode.type === layoutTree.TreeNodeTypes.COL) {
    newNode.children = newNode.children.filter(child => {
      // only put features in the renderable layout that meet all
      // their conditions or don't have conditions (undefined).
      if (child.type === layoutTree.TreeNodeTypes.FEATURE) {
        var _child$options, _child$options$condit;
        return ((_child$options = child.options) === null || _child$options === void 0 ? void 0 : (_child$options$condit = _child$options.conditions) === null || _child$options$condit === void 0 ? void 0 : _child$options$condit.every(condition => {
          if (condition.type === layoutTree.ConditionType.SHIPMENT_STATUS) {
            return evaluateCondition(condition.status, condition.operator, status);
          }
          if (condition.type === layoutTree.ConditionType.SUB_STATUS) {
            return evaluateCondition(condition.subStatus, condition.operator, subStatus);
          }
          if (condition.type === layoutTree.ConditionType.CARRIER_MONIKER) {
            return evaluateCondition(condition.carrierMoniker, condition.operator, carrier);
          }
          if (condition.type === layoutTree.ConditionType.CATEGORY) {
            return evaluateCondition(condition.category, condition.operator, category);
          }
          return true;
        })) !== false;
      } else {
        return filterLayoutForConditions(child, status, subStatus, carrier, category);
      }
    });
  } else if (newNode.type === layoutTree.TreeNodeTypes.VIEW) {
    newNode.children = newNode.children.map(child => filterLayoutForConditions(child, status, subStatus, carrier, category));
  }
  return newNode;
};
const LayoutComponent = _ref => {
  let {
    deviceLayout,
    view = defaultViewRenderProp,
    row = defaultRowRenderProp,
    col = defaultColRenderProp,
    feature
  } = _ref;
  const {
    state: {
      carrier,
      trackingStatus,
      category,
      trackingStatusCode
    }
  } = nthHookContextPage.usePageContext();
  const nthBitGridEnabled = growthbookReact.useFeatureIsOn('nth-bit-grid');
  if (!deviceLayout) return null;
  const filteredLayout = filterLayoutForConditions(deviceLayout, trackingStatus ?? layoutTree.DEFAULT_NARVAR_STATUS, trackingStatusCode ?? '', carrier ?? '', category ?? '');
  return renderLayout["default"]({
    node: filteredLayout,
    isCssGridEnabled: nthBitGridEnabled,
    view,
    row,
    col,
    feature
  });
};

exports["default"] = LayoutComponent;
